// @ts-check
import {Tag} from '@/components/atoms'
import {DragDropProvider} from '@dnd-kit/react'
import {useSortable} from '@dnd-kit/react/sortable'
import {AccordionItemV2, Font, Icon} from 'pepsico-ds'
import {SubcategoryItem} from './SubcategoryItem'
import {getCatalogItemName, getHiddenSubcategoriesCount} from './utils/productCatalogUtils'

/**
 * @param {{
 *   category: import('@/types/productCatalogTypes').ProductCategory,
 *   index: number,
 *   onSubcategoryDragEnd: (categoryId: string, event: import('@dnd-kit/dom').DragEndEvent) => void,
 *   onToggleSubcategoryVisibility: (categoryId: string, subcategoryId: string) => void,
 * }} props
 */
export const CategoryItem = ({category, index, onSubcategoryDragEnd, onToggleSubcategoryVisibility}) => {
  const {ref, handleRef, isDragging} = useSortable({id: category.id, index})
  const subcategories = category.subCategories ?? []
  const categoryName = getCatalogItemName(category)
  const hiddenCount = getHiddenSubcategoriesCount(subcategories)

  return (
    <div
      ref={ref}
      className={isDragging ? 'opacity-50' : ''}
      style={{contentVisibility: 'auto', containIntrinsicSize: '56px'}}
    >
      <AccordionItemV2
        presentation="border"
        label={
          <div className="flex items-center gap-4">
            <button ref={handleRef} className="cursor-grab touch-none">
              <Icon icon="drag_indicator" />
            </button>
            <Font className="font-semibold text-gray-400">{index + 1}.</Font>
            <Font>{categoryName}</Font>
          </div>
        }
        rightAccessoryChild={
          <Tag
            text={`${hiddenCount} hidden`}
            color="gray"
            type="default"
            iconLeading="visibility_off"
            className="!bg-gray-800"
          />
        }
      >
        <DragDropProvider onDragEnd={event => onSubcategoryDragEnd(category.id, event)}>
          <div className="flex w-full flex-col gap-3 p-6">
            {subcategories.map((subcategory, subIndex) => (
              <SubcategoryItem
                key={subcategory.id}
                subcategory={subcategory}
                index={subIndex}
                onToggleVisibility={() => onToggleSubcategoryVisibility(category.id, subcategory.id)}
              />
            ))}
          </div>
        </DragDropProvider>
      </AccordionItemV2>
    </div>
  )
}
